<template>
  <el-dialog v-model="is_show_dialog" class="edit-product-popup" width="880px" :destroy-on-close="true">
    <header class="head">
      <i @click="is_show_dialog = false"><svg-icon name="close" /></i>
      <h2>Add from {{ storefront.merchant_display_name }} website</h2>
    </header>

    <div class="edit-product-form" v-loading="is_update_data">
      <div class="image">
        <figure>
          <i @click="is_show_cropper = true"><svg-icon name="pen" /></i>
          <span><img v-if="selected_image" :src="selected_image" alt="product image" /></span>
        </figure>
        <h3>
          <span>Select Image</span
          ><el-button @click="is_show_cropper = true" type="base" size="small">Change image</el-button>
        </h3>
        <ul v-if="images.length !== 0">
          <li
            v-for="(image, index) in images"
            :key="index"
            @click="selectedImage(index)"
            :class="{ selected: selected_image_index === index }"
          >
            <i class="check"><svg-icon name="checked-circle" /></i>
            <img :src="image" alt="product image" />
          </li>
        </ul>
      </div>
      <div class="edit-col">
        <el-form :model="props.product" ref="form_el" :rules="rules">
          <el-form-item label="Product Name">
            <el-input v-model="name" size="large" placeholder="Product Name"></el-input>
          </el-form-item>
          <el-form-item label="Brand">
            <el-autocomplete
              v-model="selected_brand_name"
              :fetch-suggestions="querySearch"
              popper-class="custom-autocomplete"
              placeholder="Brand name"
              @select="handleSelect"
              size="large"
            >
              <template #prepend>
                <el-avatar v-if="selected_brand" :src="selected_brand.image" size="small" fit="contain" />
                <el-avatar v-else size="small" />
              </template>
              <template #default="{ item }">
                <div class="brand-item">
                  <el-avatar :src="item.image" size="small" fit="contain" />
                  <p>{{ item.name }}</p>
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="Product Price" class="price-input">
            <el-select v-model="currency" size="large" style="width: 240px" popper-class="price-select-popper">
              <el-option v-for="item in currencys" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-input v-model="price" size="large" placeholder="Ex. 100" />
          </el-form-item>
          <el-form-item>
            <el-checkbox value="yes" name="is_checked" v-model="is_checked">
              By checking this box, I am agreeing to the Terms of Use and Privacy Policy.
            </el-checkbox>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="large" :disabled="!is_can_submit" @click="manualRntryProduct">Add product</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="is_show_cropper"
    title="Upload product image"
    width="780px"
    class="upload-dialog"
    :destroy-on-close="true"
  >
    <upload-image @save="saveImage" :maxSize="1024 * 3" :useType="'product'"/>
  </el-dialog>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import UploadImage from './UploadImage.vue';
import { ElDialog, ElButton, ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElCheckbox, ElAutocomplete, ElAvatar } from 'element-plus';

const emit = defineEmits(['selected']);
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;

const is_show_dialog = ref(false);
const is_show_cropper = ref(false);
const is_update_data = ref(false);
const props = defineProps({
  product: {
    type: Object,
    default: () => ({}),
  },
  product_url: {
    type: String,
    default: '',
  },
  storefront: {
    type: Object,
    default: () => ({}),
  },
});

const selected_brand = ref(null);
const selected_brand_name = ref('');
const selected_brand_id = ref(0);
const selected_image_index = ref(-1);
const selected_image = ref('');
const selected_image_file = ref(null);
const is_checked = ref('');
const images = ref([]);

const currencys = [
  { value: 'USD', label: 'USD' },
  { value: 'CAD', label: 'CAD' },
  { value: 'GBP', label: 'GBP' },
  { value: 'EUR', label: 'EUR' },
  { value: 'AUD', label: 'AUD' },
  { value: 'CNY', label: 'CNY' },
  { value: 'JPY', label: 'JPY' },
  { value: 'HKD', label: 'HKD' },
  { value: 'SGD', label: 'SGD' },
  { value: 'BRL', label: 'BRL' },
];

const currency = ref('USD');
const price = ref('');
const name = ref('');

const manualRntryProduct = () => {
  is_update_data.value = true;
  const form_data = new FormData();
  form_data.append('product_page_url', props.product_url);
  form_data.append('merchant_account_id', props.storefront.id);
  form_data.append('product_name', name.value);
  form_data.append('price', price.value);
  form_data.append('currency', currency.value);

  if (selected_brand_id.value) {
    form_data.append('brand_id', selected_brand_id.value);
  } else {
    form_data.append('brand_name', selected_brand_name.value);
  }

  if (selected_image_index.value === -1) {
    form_data.append('image_type', 2);
    form_data.append('image', selected_image_file.value);
  } else {
    form_data.append('image_type', 1);
    form_data.append('image_original_url', selected_image.value);
  }

  if (props.product.color) {
    form_data.append('color', props.product.product_id);
  }

  ajax('/storefront-curation/product/manual_entry', {
    method: 'POST',
    data: form_data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
    .then((response) => {
      const res = response.data.data;
      close();
      emit('selected', res);
      // console.log(res);
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      is_update_data.value = false;
    });
};

const is_can_submit = computed(() => {
  return (
    selected_image.value &&
    (selected_brand_name.value || selected_brand_id.value) &&
    is_checked.value &&
    price.value &&
    name.value &&
    selected_brand.value &&
    selected_image.value
  );
});

const selectedImage = (index) => {
  selected_image_index.value = index;
  selected_image.value = images.value[index];
};

const blobToFile = (blob, fileName) => {
  // Create a File from Blob
  return new File([blob], fileName, {
    type: blob.type,
    lastModified: new Date().getTime(),
  });
};

const saveImage = (data) => {
  // console.log(data);

  const fileName = `product-image-${Date.now()}.${data.type.split('/')[1]}`;
  const file = blobToFile(data.data, fileName);
  selected_image_file.value = file;
  selected_image_index.value = -1;
  selected_image.value = data.src;
  is_show_cropper.value = false;
};

const querySearch = (queryString, cb) => {
  selected_brand_id.value = 0;
  if (!queryString) {
    cb([]);
    return;
  }

  ajax.get('/storefront-curation/brands-list?keyword=' + queryString).then((res) => {
    cb(res.data.data.data);
  });
};

const handleSelect = (item) => {
  selected_brand.value = item;
  selected_brand_name.value = item.name;
  selected_brand_id.value = item.id;
};

const open = () => {
  is_show_dialog.value = true;
  console.log('props.product', props.product);

  if (props.product.brand) {
    selected_brand.value = props.product.brand;
    selected_brand_name.value = props.product.brand.name;
  }

  if (props.product.product_images) {
    images.value = props.product.product_images;
    selectedImage(0);
  }

  if (props.product.product_price) {
    price.value = props.product.product_price;
  }

  if (props.product.product_names) {
    name.value = props.product.product_names[0];
  }
};

const close = () => {
  is_show_dialog.value = false;
};

defineExpose({
  open,
  close,
});
</script>

<style lang="scss">
.edit-product-popup {
  padding: 0;
  overflow: auto;
  max-height: 80%;

  .el-dialog__header {
    display: none;
  }

  .head {
    display: flex;
    align-items: center;
    padding: 16px 16px 12px;
    position: sticky;
    top: 0;
    background-color: var(--Bg-light);
    z-index: 12;

    i {
      cursor: pointer;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 4px 0 0;
      color: var(--Text-primary);

      svg {
        width: 16px;
        height: 16px;
      }
    }

    h2 {
      font: var(--medium-20);
      color: var(--Text-primary);
    }

    @media screen and (max-width: $mobile_size) {
      i {
        width: 22px;
        height: 22px;

        svg {
          width: 12px;
          height: 12px;
        }
      }

      h2 {
        font: var(--medium-16);
      }
    }
  }

  .edit-product-form {
    display: flex;
    padding: 16px;

    .image {
      order: 2;
      margin-left: 16px;
      width: 46%;

      figure {
        position: relative;
        display: block;

        i {
          position: absolute;
          height: 32px;
          width: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 3;
          cursor: pointer;
          right: -8px;
          box-shadow: var(--bot-2dp);
          top: -8px;
          background-color: var(--Bg-light);
          border-radius: var(--radius);
          color: var(--Text-secondary);

          svg {
            width: 18px;
            height: 18px;
          }

          &:hover {
            color: var(--Text-brand);
          }
        }

        span {
          width: 100%;
          height: 0;
          padding-top: 100%;
          position: relative;
          overflow: hidden;
          border-radius: var(--radius);
          background-color: var(--Bg-01);
          display: block;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      h3 {
        margin: 16px 0;
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
          font: var(--medium-14);
          color: var(--Text-secondary);
        }
      }

      ul {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        margin-top: 16px;
        gap: 12px;

        li {
          cursor: pointer;
          border-radius: var(--radius);
          overflow: hidden;
          background-color: var(--Bg-01);
          border: 1px solid transparent;
          position: relative;

          &::before {
            content: '';
            display: block;
            padding-top: 100%;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            position: absolute;
            top: 0;
            left: 0;
          }

          i {
            position: absolute;
            bottom: 4px;
            right: 4px;
            color: var(--Text-brand);
            background-color: #f6f0e7;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 3;

            &::before {
              display: block;
              height: 14px;
              width: 14px;
              border-radius: 50%;
              border: 2px solid var(--Text-default);
              content: '';
            }

            svg {
              width: 20px;
              height: 20px;
              display: none;
            }
          }

          &.selected {
            border-color: var(--Text-brand);

            i {
              svg {
                display: block;
              }

              &::before {
                display: none;
              }
            }
          }
        }
      }
    }

    .edit-col {
      flex: 1;
      order: 1;

      .el-form-item {
        margin-bottom: 16px;
        display: block;

        &.price-input {
          .el-form-item__content {
            align-items: center;
            flex-wrap: nowrap;

            .el-select {
              max-width: 100px;
              margin-right: 12px;
            }
          }
        }

        .el-form-item__content {
          margin-left: auto !important;
        }

        .el-autocomplete {
          .el-input-group__prepend {
            padding-left: 12px;
            padding-right: 0;
            background-color: var(--Bg-light);
            border: none !important;
            position: relative;
            box-shadow: unset;
            position: absolute;
            z-index: 3;
            background-color: transparent;

            // &::before {
            //   position: absolute;
            //   width: 1px;
            //   height: calc(100% - 2px);
            //   right: -1px;
            //   top: 1px;
            //   content: '';
            //   background-color: white;
            //   z-index: 3;
            // }
          }

          .el-input__wrapper {
            border-top-left-radius: var(--radius);
            border-bottom-left-radius: var(--radius);
            padding-left: 46px;
          }
        }

        .el-form-item__label {
          width: auto !important;
          font: var(--medium-14);
          color: var(--Text-primary);
          padding-bottom: 4px;
          height: auto;
        }

        .el-checkbox__label {
          font: var(--medium-12);
          color: var(--Text-secondary);
          margin-left: 0;
        }

        .el-input {
          width: 100%;
        }
      }

      .el-button {
        width: 100%;
      }
    }

    @media screen and (max-width: $mobile_size) {
      flex-direction: column;

      .image {
        width: 100%;
        margin-left: 0;

        figure {
          i {
            right: 0;
            top: 0;
          }
        }

        h3 {
          margin: 16px 0;
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          & > span {
            flex: 1;
            font: var(--medium-14);
            color: var(--Text-secondary);
            margin: 0 auto 16px;
          }

          .el-button {
            margin: 0 auto;
          }
        }

        ul {
          margin: 16px 0;
          grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));

          li {
            i {
              bottom: 0;
              right: 0;
            }
          }
        }
      }

      .col {
        width: 100%;
        order: 2;

        .el-form-item {
          margin-bottom: 16px;

          .el-form-item__label {
            font: var(--medium-14);
            color: var(--Text-primary);
            padding-bottom: 4px;
            height: auto;
          }

          .el-checkbox__label {
            font: var(--medium-12);
            color: var(--Text-secondary);
            margin-left: 0;
          }

          .el-input {
            width: 100%;
          }
        }

        .el-button {
          width: 100%;
        }
      }
      
    }
  }
}

.custom-autocomplete {
  .brand-item {
    display: flex;
    align-items: center;
    padding: 12px 0;

    .el-avatar {
      margin-right: 8px;
    }

    p {
      font: var(--medium-14);
      color: var(--Text-primary);
    }
  }
}

</style>
